/**
 * Copyright (c) Granthika Co., All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 */
import Vue from 'vue'
import App from './App.vue'
import './assets/style.scss'
import fireclient from "./service/firebase-client"
import vuetify from './plugins/vuetify'

declare var __REDIRECT_WHEN_TOP__: string
var redirectWhenTop = __REDIRECT_WHEN_TOP__

if (self == top)
  console.log("top ",  redirectWhenTop)
// if window is not a frame and we want to redirect
// __REDIRECT_WHEN_TOP__ is a compile time variable, see vue.config.js
if (self == top && redirectWhenTop && !fireclient.isSignInWithEmailLink()) {
  window.location.href =  redirectWhenTop
}

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
